
<align v-if="showFilterResults" class="filter-results">
  <div v-if="typeof results === 'number' && resultsString">
    <b>{{ resultsString }}</b> {{ results === 1 ? 'result' : 'results' }}
  </div>

  <align v-if="filterDescription" small-gap>
    <span>{{ filterDescription }}</span>

    <icon-button
      size="18"
      icon="close"
      @click="$emit('clear')"
    />
  </align>
</align>
